// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SEND_REVIEW = "Ode\u0161li hodnocen\u00ed";
export const CANCEL = "Zru\u0161";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const NEW_REVIEW = "Nov\u00e9 hodnocen\u00ed";
export const REVIEW_RATING_LABEL_BUYER = "Jak jsi spokojen\u00e1 s prod\u00e1vaj\u00edc\u00ed?";
export const REVIEW_RATING_LABEL_SELLER = "Jak jsi spokojen\u00e1 s kupuj\u00edc\u00ed?";
export const REVIEW_RATING_UNSATISFIED = "Nejsem spokojen\u00e1 - negativn\u00ed hodnocen\u00ed";
export const REVIEW_RATING_VERY_SATISFIED = "Jsem spokojen\u00e1 - pozitivn\u00ed hodnocen\u00ed";
export const SELECT = "Vyber..";
